import { css } from "@emotion/react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { CompleteResetPasswordForm } from "../components/CompleteResetPasswordForm";
import { SiteLayout } from "../components/SiteLayout";
import { useResetPasswordFormState } from "../hooks/useResetPasswordFormState";
//import { useSiteLayoutState } from "../hooks/useSiteLayoutState";

export type CompleteResetPasswordPageProps = {
	type:
		| "completeresetpassword"
		| "completeregistration"
		| "completechangepassword";
};
export const CompleteResetPasswordPage: React.FC<
	CompleteResetPasswordPageProps
> = (props) => {
	const [searchParams /*, setSearchParams*/] = useSearchParams();
	const email = searchParams.get("email") || "";
	const token = searchParams.get("token") || "";

	const resetPasswordFormState = useResetPasswordFormState();

	useEffect(() => {
		resetPasswordFormState.setIsPopup(false);
		const newemail = searchParams.get("email") || "";
		const newtoken = searchParams.get("token") || "";

		//console.log('Reset Password:', search, email, token);
		if (newemail && newtoken) {
			//console.log(2)
			resetPasswordFormState.setEmail(newemail);
			resetPasswordFormState.setTemporaryPassword(newtoken);
		}
	}, [resetPasswordFormState, searchParams]);

	return (
		<SiteLayout
			title={resetPasswordFormState.translate("Reset Password")}
			mainChildren={
				<div
					css={css`
                flex:1 1 0;`}
				>
					<div
						css={css`
                    display:flex;
                    justify-content:center;
                    align-items:center;`}
					>
						{email && token && <CompleteResetPasswordForm type={props.type} />}
					</div>
				</div>
			}
		/>
	);
};
